import { useMemo } from 'react';

import ApiCalls from '../../components/api/apiCalls';
import AssetTypesService from '../../components/services/AssetTypesService';

const useAssetTypesService = () => {
  return useMemo(() => new AssetTypesService(new ApiCalls()), []);
};

export default useAssetTypesService;
